import { useLang } from "@/contexts/LangContext";
import { LEGAL_DOCS, legalPath } from "@/const/legal";

export function LegalLinks({ className = "", testId = "legal-links" }) {
  const { t } = useLang();
  return (
    <nav className={`legal-links ${className}`.trim()} aria-label={t("legal_nav_aria")} data-testid={testId}>
      {LEGAL_DOCS.map((doc) => (
        <a
          key={doc.slug}
          className="legal-link"
          href={legalPath(doc.slug)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-${doc.slug}`}
        >
          {t(doc.titleKey)}
        </a>
      ))}
    </nav>
  );
}
